export class AmberApi {
    static readonly Flags = 'flags';
    static readonly Data = 'data'; 
}


// WEBPACK FOOTER //
// ./src/app/core/models/api-helpers.ts